import { CodeEditor } from '@acrodata/code-editor';
import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatError, MatFormField, MatHint, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatToolbar } from '@angular/material/toolbar';
import { languages } from '@codemirror/language-data';

import { SecretInputToggleComponent } from 'app/shared/components/secret-input-toggle.component';
import { Fulfiller, FulfillerClient } from 'app/shared/graph';

export interface EditFulfillerDialogResult {
    client?: FulfillerClient;
    appKey?: string;
    url?: string;
    libraryPackage?: string;
    fulfillerAppId?: string;
    mappingScript?: string;
}

@Component({
    templateUrl: './edit-fulfiller-dialog.component.html',
    styleUrls: ['../../../shared/utilities/full-screen-dialog.scss', './edit-fulfiller-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatToolbar, MatIconButton, MatDialogClose, MatIcon, MatButton, FormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatInput, MatError, SecretInputToggleComponent, MatSuffix, MatHint, CodeEditor]
})
export class EditFulfillerDialogComponent {
    languages = languages;

    data = inject<Fulfiller>(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<EditFulfillerDialogResult>>(MatDialogRef);


    fulfillerInfo: EditFulfillerDialogResult;

    clients = Object.values(FulfillerClient);

    constructor() {
        const data = this.data;

        this.fulfillerInfo = {
            appKey: '',
            url: data.url,
            client: data.client,
            fulfillerAppId: data.fulfillerAppId,
            libraryPackage: data.libraryPackage,
            mappingScript: data.mappingScript?.script ?? ''
        } as EditFulfillerDialogResult;
    }

    valid() {
        this.dialogRef.close(this.fulfillerInfo);
    }
}
